import React from 'react'
import { Button, Popconfirm, Space } from 'antd'
import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { ICellRendererParams } from 'ag-grid-enterprise'
import { useTranslation } from 'react-i18next'
import { Company } from '../../../types/company/Company'

export interface SubsidiariesActionsContext {
  onEdit: (company: Company) => void
  onDelete: (company: Company) => void
}

interface SubsidiariesActionsCellRendererParams extends ICellRendererParams<Company> {
  context: SubsidiariesActionsContext
}

const SubsidiariesActionsCellRenderer: React.FC<SubsidiariesActionsCellRendererParams> = ({ data, context }) => {
  const { t } = useTranslation()

  if (!data) return null

  const { onEdit, onDelete } = context

  return (
    <Space>
      <Button
        data-cy={`subsidiary-edit-btn-${data.id}`}
        icon={<EditOutlined />}
        type="text"
        size="small"
        onClick={() => onEdit(data)}
      />
      <Popconfirm
        placement="bottomRight"
        title={t('global:delete-confirm')}
        onConfirm={() => onDelete(data)}
        okText={t('global:yes')}
        cancelText={t('global:no')}
      >
        <Button
          data-cy={`subsidiary-delete-btn-${data.id}`}
          icon={<DeleteOutlined />}
          type="text"
          size="small"
          danger
        />
      </Popconfirm>
    </Space>
  )
}

export default SubsidiariesActionsCellRenderer
